import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["type", "modifierType", "block", "icon", "wrapIcon", "loading", "disabled", "shadow", "noPadding", "size", "weight", "justify", "reverseIcon", "noBorder", "badgeProps", "href", "tag", "htmlType", "external", "ellipsis", "rel", "target", "download", "noRouterLink", "style", "linkProps", "className", "children"],
  _excluded2 = ["spacing", "justify", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuBadge from "../DixuBadge/DixuBadge";
import Link from 'next/link';
import React, { forwardRef } from 'react';
import { isStorybookEnv } from "../../utils/EnvUtils";
import { toRem } from "../../utils/Utils";
const InnerButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    passedProps,
    renderedIcon,
    children,
    badgeProps,
    Tag
  } = _ref;
  return /*#__PURE__*/React.createElement(Tag, _objectSpread({}, passedProps.inner), renderedIcon && /*#__PURE__*/React.createElement("span", {
    className: "dixu-button__icon",
    "aria-hidden": "true"
  }, renderedIcon), children && /*#__PURE__*/React.createElement("span", {
    className: "dixu-button__text"
  }, children), badgeProps && /*#__PURE__*/React.createElement("span", {
    className: "dixu-button__badge"
  }, /*#__PURE__*/React.createElement(DixuBadge, badgeProps)));
});
const DixuButton = _ref2 => {
  let {
      type,
      modifierType,
      block,
      icon,
      wrapIcon,
      loading,
      disabled,
      shadow,
      noPadding,
      size,
      weight,
      justify,
      reverseIcon,
      noBorder,
      badgeProps,
      href,
      tag,
      htmlType,
      external,
      ellipsis,
      rel,
      target,
      download,
      noRouterLink,
      style,
      linkProps,
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const activeBlock = (() => {
    const blockRanges = Array.isArray(block) ? block : [block];
    return blockRanges;
  })();
  const renderedIcon = loading ? /*#__PURE__*/React.createElement(LoadingOutlined, null) : icon;
  const Tag = (() => {
    if (typeof tag !== 'undefined') {
      return tag;
    }
    if (href != null) {
      return 'a';
    }
    return 'button';
  })();
  const noLink = noRouterLink || Tag !== 'a' || isStorybookEnv || external || download || !href || /^(#|tel:|mailto:)/.test(href);
  const classes = classNames('dixu-button', className, {
    'dixu-button--wrap-icon': wrapIcon,
    'dixu-button--loading': loading,
    'dixu-button--no-padding': noPadding,
    'dixu-button--with-icon': renderedIcon,
    'dixu-button--icon-only': !children,
    'dixu-button--reverse-icon': reverseIcon,
    'dixu-button--no-border': noBorder,
    'dixu-button--ellipsis': ellipsis,
    [`dixu-button--type-${type}`]: type,
    [`dixu-button--modifier-type-${modifierType}`]: modifierType,
    [activeBlock.map(e => `dixu-button--block-${e}`).join(' ')]: activeBlock,
    [`dixu-button--size-${size}`]: size,
    [`dixu-button--weight-${weight}`]: weight,
    [`dixu-button--justify-${justify}`]: justify,
    [`box-shadow-${shadow}`]: shadow
  });
  const passedProps = (() => {
    const props = {
      inner: _objectSpread(_objectSpread({}, rest), {}, {
        href: disabled || loading ? '' : href,
        target,
        download,
        rel,
        className: classes,
        disabled: loading || disabled,
        style: _objectSpread({
          maxWidth: toRem(ellipsis) || undefined
        }, style)
      }),
      wrapper: _objectSpread(_objectSpread({}, linkProps), {}, {
        href: disabled || loading ? '' : href,
        passHref: true
      })
    };
    if (Tag === 'button') {
      props.inner.type = htmlType;
    } else if (Tag === 'a') {
      if (external) {
        props.inner.target = target || '_blank';
        props.inner.rel = ['noopener noreferrer', rel].filter(Boolean).join(' ');
      }
    }
    return props;
  })();
  if (noLink) {
    return /*#__PURE__*/React.createElement(InnerButton, {
      Tag: Tag,
      passedProps: passedProps,
      renderedIcon: renderedIcon,
      badgeProps: badgeProps
    }, children);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({}, _objectSpread({}, passedProps.wrapper), {
    legacyBehavior: true,
    passHref: true
  }), /*#__PURE__*/React.createElement(InnerButton, {
    Tag: Tag,
    passedProps: passedProps,
    renderedIcon: renderedIcon,
    badgeProps: badgeProps
  }, children));
};
DixuButton.defaultProps = {
  type: 'outline',
  modifierType: undefined,
  icon: undefined,
  block: ['mobile'],
  wrapIcon: false,
  loading: false,
  disabled: false,
  shadow: undefined,
  noPadding: false,
  size: 'md',
  weight: 'medium',
  justify: 'center',
  reverseIcon: false,
  noBorder: false,
  badgeProps: undefined,
  tag: undefined,
  htmlType: 'button',
  external: false,
  ellipsis: undefined,
  noRouterLink: false,
  linkProps: undefined
};
const DixuButtonGroup = _ref3 => {
  let {
      spacing,
      justify,
      className,
      children
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  const classes = classNames('dixu-button-group', className, {
    'dixu-button-group': true,
    [`dixu-button-group--spacing-${spacing}`]: spacing,
    [`dixu-button-group--justify-${justify}`]: justify
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), children);
};
DixuButtonGroup.defaultProps = {
  spacing: 'md',
  justify: 'start'
};
DixuButton.Group = DixuButtonGroup;
export default DixuButton;